/**
 * @author: ritesh.dabral
 * 
 * This page imports all constants, and creates required function
 * 
 */

 import { 
    UPDATE_WHOLE_HOTSPOT_MAP_OBJECT,
    UPDATE_MODAL_LIST,
    SET_HOTSPOT_CLICKED_INDEX,
    SET_INCREMENT_CLICKED,
    SET_DECREMENT_CLICKED,
    SET_TOGGLE_HOTSPOT_VIEW,
    UPDATE_HOTSPOT_DATA_INTERIOR,
    SET_DROPDOWN_SELECTION,
    SET_INTERIOR_HOTSPOT_INDEX,
    SET_INCREMENT_CLICKED_INTERIOR,
    SET_DECREMENT_CLICKED_INTERIOR,
    SET_IS_360_INDEX,
    SET_IS_360_INT_INDEX,
    SET_TOGGLE_INTERIOR_HOTSPOT,
    UPDATE_INTERIOR360_URL
   } from './View360ActionType'
  

   export const updateWholeHotSpotMapObj = (newHotSpotMapObj)=>{
     return {
       type: UPDATE_WHOLE_HOTSPOT_MAP_OBJECT,
       payload: newHotSpotMapObj,
       info: 'View360 Component - updateWholeHotSpotMapObj for entire view360 ActionController'
     }
   }

   export const setToggleHotspotView = (value) => ({
    type: SET_TOGGLE_HOTSPOT_VIEW,
    payload: value,
    info: 'View360 Component - setToggleHotspotView'
});
    
   export const setHotspotClickedIndex = (index) => ({
    type: SET_HOTSPOT_CLICKED_INDEX,
    payload: index,
    info: 'View360 Component - setHotspotClickedIndex'
   });

   export const setIncrementClicked = (value) => {
    return {
        type: SET_INCREMENT_CLICKED,
        payload: value,
    };
};

export const setDecrementClicked = (value) => ({
    type: SET_DECREMENT_CLICKED,
    payload: value,
});

   export const updateModalList = (modalList) => ({
    type: UPDATE_MODAL_LIST,
    payload: modalList
});

export const updateHotspotDataInterior = (hotspotDataInterior) => ({
  type: UPDATE_HOTSPOT_DATA_INTERIOR,
  payload: hotspotDataInterior,
});

export const setDropdownSelection = (selection) => ({
  type: SET_DROPDOWN_SELECTION,
  payload: selection,
});

export const setInteriorHotspotIndex = (index) => ({
  type: SET_INTERIOR_HOTSPOT_INDEX,
  payload: index,
});

export const setIncrementClickedInterior = (value) => ({
  type: SET_INCREMENT_CLICKED_INTERIOR,
  payload: value,
});

export const setDecrementClickedInterior = (value) => ({
  type: SET_DECREMENT_CLICKED_INTERIOR,
  payload: value,
});

export const setIs360IndexRedux = (index) => ({
  type: SET_IS_360_INDEX,
  payload: index
});

export const setIs360IntIndexRedux = (index) => ({
  type: SET_IS_360_INT_INDEX,
  payload: index
});

export const setToggleInteriorHotspot = (toggle) => ({
  type: SET_TOGGLE_INTERIOR_HOTSPOT,
  payload: toggle
});

export const updateInterior360Url = (urls) => ({
  type: UPDATE_INTERIOR360_URL,
  payload: urls
});

  // exports
  const view360ActionControllers = {
    updateWholeHotSpotMapObj,
    setHotspotClickedIndex,
    setIncrementClicked,
    setDecrementClicked,
    setToggleHotspotView,
    updateHotspotDataInterior,
    setDropdownSelection,
    setInteriorHotspotIndex,
    setIncrementClickedInterior,
    setDecrementClickedInterior,
    setIs360IndexRedux,
    setIs360IntIndexRedux,
    setToggleInteriorHotspot,
    updateInterior360Url
  }
  
  export default view360ActionControllers;